module.exports = __webpack_public_path__ + "components/promo-premium/static/premium-bg-678ddc793186ccc0459f2244886b3349.jpg";